import React from 'react';
import { Users, Truck, Handshake, Leaf, GraduationCap, DollarSign, Heart } from 'lucide-react';
import { useLanguage } from '../hooks/useLanguage';
export function Partnership() {
  const {
    t
  } = useLanguage();
  const partners = [{
    icon: Users,
    label: t.partnership.partners.items[0]
  }, {
    icon: Handshake,
    label: t.partnership.partners.items[1]
  }, {
    icon: Truck,
    label: t.partnership.partners.items[2]
  }];
  const principles = [{
    icon: Leaf,
    label: t.partnership.sustainability.items[0]
  }, {
    icon: GraduationCap,
    label: t.partnership.sustainability.items[1]
  }, {
    icon: DollarSign,
    label: t.partnership.sustainability.items[2]
  }, {
    icon: Heart,
    label: t.partnership.sustainability.items[3]
  }];
  return <section className="w-full py-16 md:py-24 bg-gray-50" data-id="element-180">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-181">
        {/* Section Header */}
        <div className="text-center mb-12" data-id="element-182">
          <span className="inline-block px-4 py-1.5 bg-emerald-100 text-emerald-700 rounded-full text-sm font-semibold mb-4" data-id="element-183">
            {t.partnership.badge}
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-184">
            {t.partnership.title}
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-185">
            {t.partnership.subtitle}
          </p>
        </div>

        {/* Split Section */}
        <div className="grid md:grid-cols-2 gap-6 md:gap-8" data-id="element-186">
          {/* Partners Card */}
          <div className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100" data-id="element-187">
            <h3 className="text-xl font-bold text-gray-900 mb-6" data-id="element-188">
              {t.partnership.partners.title}
            </h3>
            <div className="space-y-4" data-id="element-189">
              {partners.map((partner, index) => <div key={index} className="flex items-center gap-4 p-4 bg-emerald-50 rounded-xl" data-id="element-190">
                  <div className="w-12 h-12 bg-emerald-100 rounded-xl flex items-center justify-center" data-id="element-191">
                    <partner.icon className="w-6 h-6 text-emerald-700" data-id="element-192" />
                  </div>
                  <span className="text-gray-700 font-medium" data-id="element-193">
                    {partner.label}
                  </span>
                </div>)}
            </div>
          </div>

          {/* Sustainability Card */}
          <div className="bg-gradient-to-br from-emerald-700 to-emerald-800 rounded-2xl p-8 shadow-lg text-white" data-id="element-194">
            <h3 className="text-xl font-bold mb-6" data-id="element-195">
              {t.partnership.sustainability.title}
            </h3>
            <div className="space-y-4" data-id="element-196">
              {principles.map((principle, index) => <div key={index} className="flex items-center gap-4 p-4 bg-white/10 rounded-xl backdrop-blur-sm" data-id="element-197">
                  <div className="w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center" data-id="element-198">
                    <principle.icon className="w-6 h-6 text-emerald-200" data-id="element-199" />
                  </div>
                  <span className="text-emerald-100 font-medium" data-id="element-200">
                    {principle.label}
                  </span>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}